/**
 * ProductListing.js — Paginated search-result grid wrapper (Search context).
 *
 * Identical in purpose to ProductListing/ProductListing.js but used within the
 * Search feature, pointing to the Search-scoped ProductGrid component.
 *
 * Props: same as ProductListing/ProductListing.js.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, { useEffect } from 'react';
import { Col } from 'react-bootstrap';
import ProductGridNew from '../ProductListing/ProductGrid/ProductGridNew'


export const ProductListing = (props) => {

  /***
   * Values from Parent component
   */
  const totalProduct = props.data.length;
  const offset = (props.currentPage - 1) * props.pageSize;
  const nextt = props.currentPage * props.pageSize
  const newdata = props.data.slice(offset, nextt);
  const { statehandler } = props;

  /***
   * Return total product to main component
   */
  useEffect(() => {
    statehandler(totalProduct);
  }, [totalProduct, statehandler]);

  /**
   * retutn product grid
   */

  if (newdata.length === 0) {

    return (
      <div><h4>No programs could be found under the current search criteria</h4></div>
    )
  }
  return newdata.map(products => {
    let product = Object.values(products)[1];
    return (
      <Col lg={3} md={6} xs={12} key={product.handle+Math.random()}>
        <ProductGridNew
          product={product}
          GAurl={props.GAurl}
          Program_structure_images={props.Program_structure_images}
          AddtoCart={props.AddtoCart}
          is_ten_minite_less={props.is_ten_minite_less}
          program_date_is_gone_or_not={props.program_date_is_gone_or_not}
          AddtoWishlist={props.AddtoWishlist}
          getAllWishlist={props.getAllWishlist}
          EngineURL={props.EngineURL}
        />
      </Col>
    );
  });
}
